import { useState } from 'react';

const faqs = [
  {
    q: '出張買取の費用はかかりますか？',
    a: '出張費用・査定費用は一切無料です。ご自宅や職場へ専門スタッフが伺い、無料で査定いたします。査定後に売却しないことも可能です。',
  },
  {
    q: 'どのようなものを買い取ってもらえますか？',
    a: '貴金属・宝石・ブランド品・カメラ・お酒・金券・骨董品・家電・楽器・電動工具・ゲーム・スマホ・タブレットなど幅広く対応しております。お手持ちの品についてはお気軽にご相談ください。',
  },
  {
    q: '買取金額はどのように決まりますか？',
    a: '市場価値、状態、ブランド・モデル・希少性などを総合的に判断して査定いたします。専門知識を持つスタッフが適正価格でご提示します。',
  },
  {
    q: 'カードショップまんがくでの買取は事前予約が必要ですか？',
    a: '事前予約なしで店頭にてカードの買取・販売を承っております。大量の場合は事前にご連絡いただけるとスムーズです。',
  },
  {
    q: 'まんがくではどのカードゲームを取り扱っていますか？',
    a: 'ポケモンカード・ワンピースカード・ユニオンアリーナ・デュエルマスターズ・ヴァイスシュバルツを取り扱っております。',
  },
  {
    q: '買取の際に必要なものはありますか？',
    a: '身分証明書（運転免許証・マイナンバーカード等）が必要です。古物営業法の規定により、ご本人確認をお願いしております。',
  },
  {
    q: 'まとめ売りでの割増はありますか？',
    a: 'まとめてお売りいただく場合、状況によって特別査定をご提示できる場合があります。まずはお気軽にご相談ください。',
  },
];

export default function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  const toggle = (idx: number) => setOpenIdx(openIdx === idx ? null : idx);

  return (
    <section id="faq" className="py-24 bg-primary-pale">
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="flex flex-col items-center text-center mb-16">
          <span className="text-xs tracking-[0.3em] text-primary font-medium uppercase mb-3">FAQ</span>
          <h2 className="text-4xl md:text-5xl font-serif text-primary mb-4">よくある質問</h2>
          <div className="w-16 h-0.5 bg-primary/30 mx-auto"></div>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="bg-white rounded-xl overflow-hidden"
            >
              <button
                onClick={() => toggle(idx)}
                className="w-full flex items-center justify-between px-7 py-5 text-left cursor-pointer hover:bg-gray-50 transition-colors"
              >
                <div className="flex items-start gap-4">
                  <span className="text-primary font-serif font-semibold text-lg flex-shrink-0 mt-0.5">Q</span>
                  <span className="text-sm font-medium text-gray-800 leading-relaxed">{faq.q}</span>
                </div>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 ml-4 transition-transform duration-200 ${openIdx === idx ? 'rotate-180' : ''}`}>
                  <i className="ri-arrow-down-s-line text-primary text-lg"></i>
                </div>
              </button>

              {openIdx === idx && (
                <div className="px-7 pb-5 animate-fadeIn">
                  <div className="flex items-start gap-4 pt-1 border-t border-gray-100">
                    <span className="text-accent font-serif font-semibold text-lg flex-shrink-0 mt-3">A</span>
                    <p className="text-sm text-gray-600 leading-relaxed mt-3">{faq.a}</p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-sm text-gray-500 mb-4">上記以外のご不明点はお気軽にお問い合わせください</p>
          <button
            onClick={() => document.querySelector('#contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="inline-flex items-center gap-2 bg-primary text-white px-8 py-3 rounded-full text-sm font-medium hover:bg-primary-light transition-colors cursor-pointer whitespace-nowrap"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-question-line text-xs"></i>
            </div>
            お問い合わせはこちら
          </button>
        </div>
      </div>
    </section>
  );
}
